import { Button, Modal } from "@moneyforward/mfx_biz_react_components";
import { css } from "@emotion/react";

type Props = {
  active: boolean;
  title?: string;
  body?: React.ReactNode;
  onClickCancel: () => void;
  onClickDelete: () => void;
};

export const DeleteConfirmModal = ({
  active,
  title = "削除します",
  body = "完全に削除され元に戻すことはできません",
  onClickCancel,
  onClickDelete,
}: Props) => {
  const addButton = (
    <>
      <Button type="button" variant="secondary" onClick={onClickCancel}>
        キャンセル
      </Button>
      <Button type="button" variant="destructive" onClick={onClickDelete}>
        削除
      </Button>
    </>
  );

  if (!active) {
    return <></>;
  }

  return (
    <div css={buttonWrapper}>
      <Modal
        title={title}
        body={body}
        zIndex={5}
        footerButtons={addButton}
        onClose={onClickCancel}
      />
    </div>
  );
};

const buttonWrapper = css({
  display: "flex",
  justifyContent: "center",
  marginBottom: "30px",
  marginTop: "8px",
});
